import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import groupList from '../../../Management/group/group.List.i18n'

import agent from '../service'

//restful api
import { agent as wsfinder } from '@/service/api/wsfinder'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  target : "agent",
  cmd : "search",
  request : "wsf",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
});

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.' , thStyle: 'width: 5%'},
    { key: 'group', label: 'Group', thStyle: 'width: 15%'},
    { key: 'is_del', label: 'Status', thStyle: 'width: 15%'},
    { key: 'setting', label: 'Backup mode'},
    { key: 'ip_addr', label: 'HOST@IP'},
    { key: 'os_type', label: 'OS' , thStyle: 'width: 10%'},
    { key: 'created_at', label: 'Installed_at', thStyle: 'width: 15%'},
  ],
  KO: [
    { key: 'id', label: '#.' , thStyle: 'width: 5%'},
    { key: 'group', label: '그룹', thStyle: 'width: 15%'},
    { key: 'is_del', label: '상태', thStyle: 'width: 15%'},
    { key: 'setting', label: '백업 모드'},
    { key: 'ip_addr', label: '호스트@IP'},
    { key: 'os_type', label: '운영체제' , thStyle: 'width: 10%'},
    { key: 'created_at', label: '설치일', thStyle: 'width: 15%'},
  ]
}

export default {
  components: { DatePicker, vSelect, groupList },
  data: () => {
    return {
      build_list : [],
      chainGroup : false,
      codes,
      moment,
      group_name : '',
      custom,
      sync : { th : undefined, stop : false, interval : 15, enable : false },
      summaryData : { enable : 0, disable : 0, total : 0 },
      //
      base_href : `${location.protocol}//${location.host}`,
      agents : [],
      show: true,
      so : default_opt(),
      th : undefined, // timer handler
      nbsp : "\u00A0",
      hide_del : true,
    }
  },
  computed: {
    fields: function () {
      return i18n_fields[this.i18n];
    },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['updated_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    reset() { this.so = default_opt(); this.group_name = undefined; this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems(ctx) {  return this.load(ctx); },
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    async load(ctx = {}) {
      let so = {
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : []  },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      // if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

      //일부 키워드 검색
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'os_type':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'version':
              cond = parseInt(this.so.opt[k[i]]) > 0 ? this.set_op(k[i], this.so.opt[k[i]]) : this.set_op('', '')
              break;
            case 'mode':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'updated_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'updated_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }

      this.getVersion()
      return wsfinder.listAgent(so).then(rs => {
          this.so.totalRows = rs.total;
          return rs.body;
        }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    async getVersion() {
      let rs = await wsfinder.versionAgent()
      this.build_list = rs.total > 0 ? rs.body : [];
    },
    async ping() {
      if(this.th) { clearTimeout(this.th); }
      if(this.agents &&  this.agents.length) {
        let mq_done = false;
        for (let i = 0; i < this.agents.length; i++) {
          let r = this.agents[i];
          if(!r.tag.startsWith("ws.")) {
            // ping to exchange
            if(mq_done) { continue; }
            else { agent.mq.Cmd("ping", '', this.exchange).then(rs => this.res(rs)); mq_done = true; }
          } else { agent.ws.Cmd("ping", `${r.id}`).then(rs => this.res(rs)); }
        }
        this.th = setTimeout(this.ping, 3000);
      }
    },
    res_ping(m) {
      if (m.pl.type != 'pong') { return; }
      _.forEach(this.agents, (agent, index) => {
        if (agent.tag == m.pl.tag) {
          let update = { ms : Math.abs(new Date().getTime() - Number(m.pl.content)), alive : true }
          this.agents[index] = _.assign(this.agents[index], update)
        }
      });
    },
    res_ping_ws(m) {
      if (m.cmd != 'pong') { return; }
      _.filter(this.agents, { id : m.agent_id }).forEach(a => {
        let update = { ms : Math.abs(new Date().getTime() - Number(m.body)), alive : true }
        this.agents[_.findIndex(this.agents, { id : m.agent_id })] = _.assign(a, update);
      });
    },
    res(m) {
      switch(m.ch) {
        case 'ws' : return this.res_ping_ws(m);
        case 'mq' : return this.res_ping(m);
      }
    },
    hideList(e) {
      this.show = !e; console.log('agent.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    },
    summary() {
      let and = [];
      if(this.group) { and.push({ name : 'group_id', value : this.group.id, op : '='}) }

      wsfinder.summaryAgent({ and : and, or : [], sort : [] })
        .then(rs => { this.summaryData = Object.assign(this.summaryData, { enable : (rs.body.total - rs.body.disable), disable : rs.body.disable, total : rs.body.total}) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item){
      this.$router.push({ name : 'wsfinder_agent', params : { id: item.id } })
    },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  created() { console.log('agent.list.vue', 'created'); this.$root.$on('select', this.setGroup); },
  destroyed() {
    console.log('agent.list.vue', 'destroyed');
    // this.signalr.off('wsfinder_response', this.res);
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
  },
  mounted() {
    console.log('agent.list.vue', 'mounted');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(!this.view_detail !== false) {
      // not component
      this.summary()
    }
    // this.signalr.on('wsfinder_response', this.res)
  },
}